var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 1.16699C4.2265 1.16699 1.1665 4.22699 1.1665 8.00033C1.1665 11.7737 4.2265 14.8337 7.99984 14.8337C11.7732 14.8337 14.8332 11.7737 14.8332 8.00033C14.8332 4.22699 11.7732 1.16699 7.99984 1.16699ZM12.2932 6.02699L7.49317 11.207C7.41317 11.2937 7.29984 11.3403 7.1865 11.347H7.17984C7.0665 11.347 6.95984 11.3003 6.87317 11.2203L3.71984 8.06699C3.55317 7.90033 3.55317 7.62699 3.71984 7.46033C3.8865 7.29366 4.15984 7.29366 4.3265 7.46033L7.15984 10.2937L11.6598 5.44033C11.8198 5.26699 12.0932 5.25366 12.2665 5.42033C12.4398 5.58033 12.4532 5.85366 12.2865 6.02699H12.2932Z",
    fill: "#26C887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSuccess);
export default __webpack_public_path__ + "static/media/info_success.da0800e6b4c1a13db2ccc61e728bd6dd.svg";
export { ForwardRef as ReactComponent };